export const isObjectEmpty = (list: any) =>
  Object.keys(list).length === 0 && list.constructor === Object;
